export default "__VITE_ASSET__BO6QI8Oa__"